import React from 'react';
import SiteFooter from '../components/footer/SiteFooter';
import SiteHeader from '../components/navigation/SiteHeader';
import SkipLink from '../components/ui/SkipLink';
import { getPublishedPosts } from '../components/writing/publishedPosts';
import styles from '../components/writing/Writing.module.css';

function BlogIndexPage({ posts }) {
  const publishedPosts = getPublishedPosts(posts);

  return (
    <>
      <SkipLink />
      <SiteHeader />
      <main className={styles.page} id="main-content">
        <div className={styles.pageHeader}>
          <p className={styles.sectionLabel}>Blog</p>
          <h1>Writing</h1>
          <p>Long-form explorations of software, machine learning, and the systems around them.</p>
        </div>
        {publishedPosts.length > 0 ? (
          <ol className={styles.indexList}>
            {publishedPosts.map((post) => (
              <li className={styles.indexItem} key={post.slug}>
                <article>
                  <p className={styles.category}>{post.category}</p>
                  <h2>
                    <a href={`/blog/${encodeURIComponent(post.slug)}/`}>{post.title}</a>
                  </h2>
                </article>
                <p className={styles.indexMeta}>
                  {post.date && <time dateTime={post.date}>{post.date}</time>}
                  {post.read_time && <span>{post.read_time}</span>}
                </p>
              </li>
            ))}
          </ol>
        ) : (
          <p>No published articles yet.</p>
        )}
      </main>
      <SiteFooter />
    </>
  );
}

export default BlogIndexPage;
